import React from "react";
import { inject, observer } from "mobx-react";
import Language from "../language/language";
import { Button } from "antd";
import { $util } from "../../helper";
import { withRouter } from "react-router-dom";
import ReactGA from "react-ga";
import "./stylesheets/personInfoNotice.scss";
import qs from "query-string";

@inject("languageStore", "gameStore", "authStore", "commonStore")
@observer
@withRouter
export default class PersonInfoNotice extends React.Component {
  componentDidMount() {
    const joinGameTitle = this.props.authStore.joinGameTitle;
    // 统计通过报名中心赛事列表点击”立即报名“唤起此弹窗的曝光。
    if (this.props.state === "0" && joinGameTitle) {
      ReactGA.event({
        category: "personlInfoPopup",
        action: "exp",
        label: `${joinGameTitle}-立即报名`
      });
      this.props.commonStore.gTag("event", "personlInfoPopup", {
        pageName: "registrationCenter",
        competitionName: joinGameTitle,
        popupName: `${joinGameTitle}-完善个人资料`
      });
    }
  }

  goToPersonCenter = () => {
    let url = this.props.location.pathname;
    // 拿到当前url的参数
    let currentParmas = this.props.location.search ? qs.parse(this.props.location.search) : "";
    // 拿到参数里id的值
    let currentId = currentParmas && currentParmas.id ? currentParmas.id : null;
    ReactGA.event({
      category: "RM_regist",
      action: "click_sup",
      label: "去完善"
    });
    this.props.commonStore.gTag("event", "completePersonalInfo", {
      pageName: "registrationCenter",
      competitionName: this.props.authStore.joinGameTitle,
      buttonName: `去完善`
    });
    if (currentParmas) {
      if (currentId) {
        // 当url的参数有id时，如果id不等于当前被点击的赛事的id，替换id；如果等于，不加id
        url =
          currentId === this.props.authStore.joinGameId
            ? url + this.props.location.search
            : url +
              this.props.location.search.replace(
                /(id=)([^&]*)/gi,
                "id=" + this.props.authStore.joinGameId
              );
      } else {
        //没有id 加上id
        url =
          this.props.authStore.joinGameId && this.props.authStore.joinGameId !== "undefined"
            ? url + this.props.location.search + "&id=" + this.props.authStore.joinGameId
            : url + this.props.location.search;
      }
    } else {
      // 当前url没有参数
      url =
        this.props.authStore.joinGameId && this.props.authStore.joinGameId !== "undefined"
          ? url + "?id=" + this.props.authStore.joinGameId
          : url;
    }
    // 改变当前url，因为$util.getPersonCenterUrl得到的url的最后一个参数from的值为window.location.href
    this.props.history.push(url);
    // fromText参数的值可能是中文 有中文的url在ie浏览器下会报错 对中文encodeURIComponent编码
    window.location.href =
      $util.getPersonCenterUrl(this.props.languageStore.lang) +
      "&fromText=" +
      encodeURIComponent(this.props.authStore.joinGameTitle);
  };
  render() {
    return (
      <div className="person-info-notice">
        <div className="description">
          {this.props.state === "0" ? (
            <Language resource="PERSION_NOTICE" />
          ) : (
            <Language resource="WORK_NOTICE" />
          )}
        </div>
        <Button className="button goto-person-center" onClick={this.goToPersonCenter}>
          <Language resource="COMPLETE_INFO" />
        </Button>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/registrationCenter/personInfoNotice.js